// extracted by mini-css-extract-plugin
module.exports = {"recommend":"Recommend_recommend__btTIa"};